import Config from 'config/config';
import { setHeaders } from 'shared/utils/url';

const restore = pms => fetch(Config.serverURL + '/user/restore/' + pms.email, {
  method: 'GET',
  headers: setHeaders()
}).then(res => res);

export default { restore };
